import { Button, Result } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';

const Error = () => {
  const navigate = useNavigate();
  const { username } = useParams();
  const location = useLocation();
  const errorInfo = location.state?.errorInfo || { title: '错误', description: '发生了未知错误' };

  // 设置网页标题
  useDocumentTitle('错误页面', {
    prefix: '',
    suffix: ' - rtycn'
  });

  const handleBackHome = () => {
    if (username) {
      navigate(`/${username}/index/`);
    } else {
      navigate('/');
    }
  };

  const handleBackToIndex = () => {
    if (username) {
      navigate(`/${username}/index/`);
    } else {
      navigate('/');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 64px)',
      padding: '24px'
    }}>
      <Result
        status="error"
        title={errorInfo.title}
        subTitle={errorInfo.description}
        extra={[
          <Button type="primary" key="home" onClick={handleBackHome}>
            返回首页
          </Button>,
          <Button key="back" onClick={handleBackToIndex}>
            返回上一页
          </Button>,
        ]}
      />
    </div>
  );
};

export default Error;
